"use client";

import { useQuery } from "@apollo/client";
import { Award } from "lucide-react";
import { HomeLoadingStateV2 } from "components/ui/v2";
import { PageEmptyStateV2 } from "components/ui/v2/maintainer";
import CertificationCard from "components/ui/v2/shared/bundle/profile/CertificationCard";
import { gqlUser } from "gql";
import useTranslation from "next-translate/useTranslation";
import { IUser, IUserCertification } from "types/User.types";

interface IUserCertificationsProps {
  userCertificated?: IUser;
  hideHeader?: boolean;
}

const UserCertifications = (props: IUserCertificationsProps) => {
  const { userCertificated, hideHeader = false } = props;
  const { t } = useTranslation("common");

  const { data, loading } = useQuery<
    { userCertifications: IUserCertification[] },
    { userId: string }
  >(gqlUser.queries.GET_USER_CERTIFICATIONS, {
    variables: {
      userId: userCertificated?.id || "",
    },
  });

  if (loading) {
    return <HomeLoadingStateV2 label={t("Cargando certificaciones")} />;
  }

  const certifications = data?.userCertifications ?? [];

  return (
    <div className="space-y-3">
      {!hideHeader ? (
        <div>
          <h3 className="text-[13px] font-semibold leading-snug text-slate-900 dark:text-zinc-50 sm:text-[15px]">
            {t("Certificaciones")}
          </h3>
          <p className="mt-1 text-[9px] leading-snug text-slate-500 dark:text-zinc-400">
            {t("Estas son las certificaciones que ha obtenido este Colaborador")}
          </p>
        </div>
      ) : null}

      <div className="flex flex-col gap-2">
        {certifications.map((certification) => (
          <CertificationCard
            {...certification}
            disableEdit
            key={certification.id}
          />
        ))}
        {certifications.length === 0 ? (
          <PageEmptyStateV2
            embedded
            variant="empty"
            icon={<Award className="h-8 w-8" />}
            title={t("Este colaborador aún no tiene certificaciones")}
            description={t(
              "Las certificaciones aparecerán aquí cuando sean agregadas al perfil"
            )}
          />
        ) : null}
      </div>
    </div>
  );
};

export default UserCertifications;
